import { config as c3Config } from "../../config";

export interface BillingRuntimeSettings {
  vectaraApiBaseUrl?: string;
  billingAgentKey?: string;
  billingOauthTokenEndpoint?: string;
}

export interface BillingConfig {
  apiBaseUrl: string;
  defaultAgentKey: string;
  oauthTokenEndpoint: string;
}

const DEFAULTS: BillingConfig = {
  apiBaseUrl: "https://api.vectara.io",
  defaultAgentKey: "customer_billing_helper",
  oauthTokenEndpoint: "https://auth.vectara.io/oauth2/token"
};

const valueOr = (value: string | undefined, fallback: string): string =>
  value && value.trim() !== "" ? value.trim() : fallback;

export const billingConfig = (settings: BillingRuntimeSettings): BillingConfig => ({
  apiBaseUrl: valueOr(settings.vectaraApiBaseUrl, DEFAULTS.apiBaseUrl).replace(/\/+$/, ""),
  defaultAgentKey: valueOr(settings.billingAgentKey, DEFAULTS.defaultAgentKey),
  oauthTokenEndpoint: valueOr(settings.billingOauthTokenEndpoint, DEFAULTS.oauthTokenEndpoint)
});

export const config = billingConfig(c3Config);
